import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiEndPoints } from 'src/app/api-end-points';
import { Globals } from '../globals';
import { Observable } from 'rxjs';
import { of } from 'rxjs';


@Injectable ({
    providedIn: 'root'
})

export class LoginService {

  constructor(private http: HttpClient, private _apiEndPoints: ApiEndPoints, private globals: Globals) {
    Inject(ApiEndPoints)
  }
  loginUser(userName: string, password: string, windowsUserName: string) {
	let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
	  var body = null;
	  if (this.globals.enableEncDecLogin) {
		  body = {
			  'userName': userName,
			  'password': this.globals.encrypt(password),
			  'windowsUserName': windowsUserName,
			  'seqcryplaw': "Yes"
		  }
	  } else {
		  body = {
			  'userName': userName,
			  'password': password,
			  'windowsUserName': windowsUserName,
			  'seqcryplaw': "No"
		  }
	  }
	  var encryptedString = this.globals.encrypt(JSON.stringify(body));
    var request = {
      "encRequest": encryptedString
    }
    let loginurl = this._apiEndPoints.filteredEndPoints['loginUserDetails'];
    return this.http.post(loginurl, request, httpOptions).pipe(map(response => {
        return response;
      }), catchError( error => {
        return of(false);
      })
    );
  }

}
